import { PolicyLevelData, Portfolio } from 'modules/sales-policies/types/sales-portfolio.interfaces';
import create from 'zustand';
import { persist } from 'zustand/middleware';

interface StoreState {
  portfolio: Portfolio;
  setPortfolio: (portfolio: Portfolio) => void;
  quoteLines: {};
  setQuoteLines: (q: Record<string, unknown>) => void;
  mtaProducts: [];
  setMTAProducts: (m: string[]) => void;
  editQuoteProducts: [];
  setEditQuoteProducts: (eq: string[]) => void;
  policyLevelData: PolicyLevelData;
  setPolicyLevelData: (policyLevelData: PolicyLevelData) => void;
}

export const usePortfolioStore = create<StoreState>(
  persist(
    (set) => ({
      portfolio: {} as Portfolio,
      setPortfolio: (portfolio) => set({ portfolio }),
      quoteLines: {},
      setQuoteLines: (quoteLines) => set({ quoteLines }),
      mtaProducts: [],
      setMTAProducts: (mtaProducts: any) => set({ mtaProducts }),
      editQuoteProducts: [],
      setEditQuoteProducts: (editQuoteProducts: any) => set({ editQuoteProducts }),
      policyLevelData: {} as PolicyLevelData,
      setPolicyLevelData: (policyLevelData) => set({ policyLevelData }),
    }),
    {
      name: 'portfolio-storage',
      getStorage: () => sessionStorage,
    }
  )
);
